module.exports = __webpack_public_path__ + "static/media/22-015.27ae2dbd.png";